// extracted by mini-css-extract-plugin
export default {"MenuItem":"CompletarCadastro_MenuItem__CxT8A","icon":"CompletarCadastro_icon__FUPBz","titleMenu":"CompletarCadastro_titleMenu__JEMzc"};